import { connect } from 'react-redux';
import {  Redirect } from 'react-router-dom';
import CircularProgress from '@material-ui/core/CircularProgress';
import { WithRouter } from 'decorators/withRouter';
import { PureComponent } from 'react';

interface IProps {
  match: any;
  isFree: boolean;
}

@WithRouter()
class SignUp extends PureComponent<IProps, any> {
  constructor(props: IProps) {
    super(props);
    this.state = { ...this.state };
  }

  render() {
    const { isFree } = this.props;
    const { courseHash } = this.props.match.params;

    if (isFree === undefined) {
      return (
        <div className='loading-sign'>
          <CircularProgress />
        </div>
      );
    }

    if (isFree === false) {
      return <Redirect to={`/${courseHash}`} />;
    }

    return <div />;
  }
}

const mapStateToProps = (state: any, ownProps: any) => ({
  ...ownProps,
  isFree: (state.template.course || {}).isFree,
});

export default connect(mapStateToProps, { })(SignUp as any);
